/**
 * Temporary - Generate Random Data
 */
export default function generateRandomData(count = 100) {
  const generateRandomString = (length = 8) =>
    Math.random()
      .toString(36)
      .substring(2, length + 2);

  const generateRiskScore = () => Math.floor(Math.random() * 100) + 1;

  const functions = ['Finance', 'IT', 'HR', 'Operations', 'Sales', 'Marketing'];
  const riskTypes = [
    'Operational',
    'Financial',
    'Strategic',
    'Compliance',
    'Reputational',
  ];
  const applications = [
    'SAP',
    'Salesforce',
    'Oracle',
    'Workday',
    'Microsoft 365',
  ];
  const actualVsPotentialValues = ['Actual', 'Potential'];

  return Array.from({ length: count }, (_, index) => ({
    riskName: `Risk-${generateRandomString(4)}-${index + 1}`,
    function: functions[Math.floor(Math.random() * functions.length)],
    riskDescription: `Description for ${generateRandomString(6)}`,
    riskScore: generateRiskScore(),
    application: applications[Math.floor(Math.random() * applications.length)],
    accountName: `ACC-${generateRandomString(6)}`,
    actualVsPotential:
      actualVsPotentialValues[
        Math.floor(Math.random() * actualVsPotentialValues.length)
      ],
    riskType: riskTypes[Math.floor(Math.random() * riskTypes.length)],
    randomColumn1: `RandomColumn1-${generateRandomString(40)}-${index + 1}`,
    randomColumn2: `RandomColumn2-${generateRandomString(40)}-${index + 1}`,
    randomColumn3: `RandomColumn3-${generateRandomString(40)}-${index + 1}`,
    randomColumn4: `RandomColumn4-${generateRandomString(40)}-${index + 1}`,
    randomColumn5: `RandomColumn5-${generateRandomString(40)}-${index + 1}`,
  }));
}
